import { createContext } from "react";
import useUserProjectSummaries from "../hooks/data/useUserProjectSummaries";

export interface IUserProjectsContext extends ReturnType<typeof useUserProjectSummaries> {

};

const UserProjectsContext = createContext<IUserProjectsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default UserProjectsContext